export const ISDEV = false;

console.log = ISDEV ? console.log : () => {};

export const BASEURL = ISDEV ? "http://192.168.192.213:3003" : "";
export const LOGINURL = BASEURL + "/login";
export const LOGOUTURL = BASEURL + "/logout";
export const SIGNUPURL = BASEURL + "/register";
export const FORGOTURL = BASEURL + "/resetpassword";
export const USERAPIURL = BASEURL + "/userapi";
export const USERCONFIGURL = USERAPIURL + "/current/config";
export const USERURL = USERAPIURL + "/current";

export const FE_VERSION = "1.3.2";
export const BE_VERSION = "1.0.1";

export const GRID_SIZE = 70;

// WIDGET INTRINSIC SIZES IN MULTIPLES OF GRID_SIZE

export const maxConnectionsForWidgetType = {
  simplenumeric: 1,
  verticalmeter: 1,
  radialgauge: 1,
  lineargauge: 1,
  linechart: 3
};

export const widgetGridDimensionsForWidgetTypes = {
  simplenumeric: {
    gridw: 2,
    gridh: 1
  },
  verticalmeter: {
    gridw: 5,
    gridh: 5
  },
  radialgauge: {
    gridw: 2,
    gridh: 2
  },
  lineargauge: {
    gridw: 2,
    gridh: 2
  },  
  linechart: {
    gridw: 4,
    gridh: 1
  },
  imageview:{
    gridw: 2,
    gridh: 2
  }
};

export var specialSettingsForWidgetTypes = {
  simplenumeric: [],
  lineargauge: [
    { name: "min_value", 
      label: 'min_val_label', 
      type: "numeric", 
      default: 0 },
    {
      name: "max_value",
      label: "max_val_label",
      type: "numeric",
      default: 100
    },
    { name: "lower_limit",
      label: "lower_limit_label",
      type: "numeric",
      default: 25  
    },
    {
      name: "upper_limit",
      label: "upper_limit_label",
      type: "numeric",
      default: 75      
    },
    {
      name: "show_ticks",
      label: "show_tickmarks_label",
      type: "bool",
      default: true
    }    
  ],
  radialgauge: [
    { name: "min_value", label: "min_val_label", type: "numeric", default: 0 },
    {
      name: "max_value",
      label: "max_val_label",
      type: "numeric",
      default: 100
    },
    { name: "lower_limit",
      label: "lower_limit_label",
      type: "numeric",
      default: 25  
    },
    {
      name: "upper_limit",
      label: "upper_limit_label",
      type: "numeric",
      default: 75      
    },
    {
      name: "show_ticks",
      label: "show_tickmarks_label",
      type: "bool",
      default: true
    }
  ],
  linechart: [
    { name: "show_axes",
      label: "show_axes_label",
      type: "bool",
       default: true },

    {
      name: "interval",
      label: "interval_label",
      type: "select",
      options: ["last_hour_label", "last_24h_label", "last_week_label", "last_month_label", "last_year_label"],
      default: 0
    }
  ],
  imageview: [
    { name: "image_url", label: "image_url_label", type: "string", default: "" },
    { name: "image_layout", label: "image_layout_label", type: "select", default: "0", options: ["Scale Down", "Contain", "Cover"] }

  ]
};

// t is the translation function
export const widgetTypeNameForWidgetType = function(type, t){
  let name = "wname"
  if (type === "simplenumeric") {
    name = "Text"
  }else{
    let transl = t("wname_"+type)
    if (transl) {
      name = transl
    }
  }
  return name
}

export const widgetTypesConsumingHistoData = ["linechart"];

export const widgetConsumesHistoData = widgettype => {
  return widgetTypesConsumingHistoData.indexOf(widgettype) !== -1;
};

export const widgetDimensionsForWidgetTypes = type => {
  let gridDimensions = widgetGridDimensionsForWidgetTypes[type];
  return {
    w: gridDimensions.gridw * GRID_SIZE,
    h: gridDimensions.gridh * GRID_SIZE
  };
};

export const sensorPropNames2Labels = {
  name: "sensorprop_name_label",
  value: "sensorprop_value_label",
  unit: "sensorprop_unit_label",
  time: "sensorprop_time_label",
  color: "sensorprop_color_label",
  geo: "sensorprop_geo_label",
  value_factor: "sensorprop_value_factor_label",
  value_offset: "sensorprop_value_offset_label"
};

export const devicePropNames2Labels = {
  name: "deviceprop_name_label",
  color: "deviceprop_color_label",
  geo: "deviceprop_geo_label"
};

export const colors = {
  selected: "rgb(0, 132, 255)",
  gray: "#838383"
};



// Presentation mode enum
export const PRESENTATION_MODE_DEFAULT = "PRESENTATION_MODE_DEFAULT",
  PRESENTATION_MODE_FIT_H = "PRESENTATION_MODE_FIT_H",
  PRESENTATION_MODE_FIT_V = "PRESENTATION_MODE_FIT_V",
  PRESENTATION_MODE_STACK_H = "PRESENTATION_MODE_STACK_H",
  PRESENTATION_MODE_STACK_V = "PRESENTATION_MODE_STACK_V";
export const PRESENTATION_MODE = {
  PRESENTATION_MODE_DEFAULT: 0,
  PRESENTATION_MODE_FIT_H: 1,
  PRESENTATION_MODE_FIT_V: 2,
  PRESENTATION_MODE_STACK_H: 3,
  PRESENTATION_MODE_STACK_V: 4
};

// Pamamoa template names corresponding to Querx devices

export const PQ_TEMPLATES = [
  { tname: "querxpt_v1", qname: "PT" },
  { tname: "querxth_v1", qname: "TH" },
  { tname: "querxthp_v1", qname: "THP" },
  { tname: "querxcn_v1", qname: "CN" }
];

// Returns false, if template does not correspond to a querx,
// else returns the corresponding querx identifier (qname).
export const templateIsQuerx = template_name => {
  let rv = false;
  for (const t of PQ_TEMPLATES) {
    console.log(template_name, t.tname);
    if (t.tname === template_name) {
      rv = t.qname;
    }
  }
  return rv;
};
